import { useEffect, useState } from 'react'
import { api, session } from '../api.js'

const MOIS = [
  [1, '1 mois'], [3, '3 mois'], [6, '6 mois'], [12, '1 an'], [24, '2 ans'],
  [36, '3 ans'], [60, '5 ans'], [120, '10 ans'],
]

// Le paramétrage se fait par démarche, jamais champ par champ : c'est ainsi que
// raisonne la CNIL, et c'est la seule échelle à laquelle une petite commune peut
// décider quelque chose de sensé.
export default function Donnees() {
  const [onglet, setOnglet] = useState('demarches')
  const [data, setData] = useState(null)
  const [registre, setRegistre] = useState(null)
  const [echeances, setEcheances] = useState([])
  const [ouverte, setOuverte] = useState(null)
  const [message, setMessage] = useState('')

  const charger = () => { api.donneesApercu().then(setData) }
  useEffect(() => {
    charger()
    api.registre().then(setRegistre).catch(() => setRegistre(null))
    api.echeances().then(setEcheances).catch(() => setEcheances([]))
  }, [])
  if (!data) return <p className="chargement">Chargement…</p>

  const lectureSeule = session.env === 'live'
  const enRetard = data.demarches.reduce((n, d) => n + d.en_retard, 0)
  const sansReglage = data.demarches.filter((d) => !d.regle).length

  return (
    <>
      <h1>Données personnelles</h1>
      <p className="chapo">Combien de temps garder les demandes, et ce qu'il en reste ensuite.
        Tout arrive pré-rempli : vous vérifiez plutôt que vous ne décidez.</p>
      {message && <p className="succes" role="status">{message}</p>}

      <div className="kpis">
        <Kpi label="Démarches réglées" valeur={`${data.demarches.length - sansReglage} / ${data.demarches.length}`}
             detail={sansReglage ? 'certaines attendent une durée' : 'toutes ont une durée de conservation'}
             alerte={sansReglage > 0} />
        <Kpi label="Dossiers anonymisés" detail="données personnelles déjà effacées"
             valeur={data.demarches.reduce((n, d) => n + d.anonymises, 0)} />
        <Kpi label="Échéances dépassées" valeur={enRetard}
             detail={enRetard ? 'seront traitées cette nuit' : 'rien en retard'} alerte={enRetard > 0} />
      </div>

      <div className="onglets" role="tablist">
        {[['demarches', 'Par démarche'], ['echeances', `À venir${echeances.length ? ` (${echeances.length})` : ''}`],
          ['registre', 'Registre des traitements']].map(([id, label]) => (
          <button key={id} role="tab" aria-selected={onglet === id}
                  className={onglet === id ? 'on' : ''} onClick={() => setOnglet(id)}>{label}</button>
        ))}
      </div>

      {onglet === 'demarches' && (
        <>
          <p className="aide">Le tri se fait tout seul chaque nuit. Personne n'a à y penser, et
            aucun agent ne peut oublier de le faire.</p>
          <table className="tableau sur-ordinateur">
            <thead>
              <tr><th>Démarche</th><th>Pièces jointes</th><th>Anonymisation</th>
                <th>Suppression</th><th>Dossiers</th><th /></tr>
            </thead>
            <tbody>
              {data.demarches.map((d) => (
                <tr key={d.key}>
                  <td><strong>{d.title}</strong><span className="cat">{d.category}</span></td>
                  <td className="mono">{libelle(d.pieces_mois)}</td>
                  <td className="mono">{libelle(d.anonymisation_mois)}</td>
                  <td className="mono">{d.suppression_mois ? libelle(d.suppression_mois) : 'jamais'}</td>
                  <td className="mono">
                    {d.dossiers}
                    {d.anonymises > 0 && <span className="tag">{d.anonymises} anonymisés</span>}
                    {d.en_retard > 0 && <span className="suspendue">{d.en_retard} en retard</span>}
                  </td>
                  <td><button className="btn sm" onClick={() => setOuverte(d)}>Régler</button></td>
                </tr>
              ))}
            </tbody>
          </table>

          <ul className="cartes-dossiers sur-mobile">
            {data.demarches.map((d) => (
              <li key={d.key}>
                <button onClick={() => setOuverte(d)}>
                  <strong>{d.title}</strong>
                  <span className="bas">
                    <span>anonymisation : {libelle(d.anonymisation_mois)}</span>
                    <span className="mono">{d.dossiers} dossiers</span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </>
      )}

      {onglet === 'echeances' && (
        <div className="carte">
          <h2>Dossiers bientôt anonymisés</h2>
          <p className="aide">Les données personnelles de ces dossiers seront effacées à la date
            indiquée. Si l'un d'eux doit être conservé plus longtemps, allongez la durée de sa
            démarche avant l'échéance.</p>
          <table className="tableau">
            <thead><tr><th>Numéro</th><th>Démarche</th><th>Effacement</th></tr></thead>
            <tbody>
              {echeances.map((e) => (
                <tr key={e.id}>
                  <td className="mono">{e.number}</td>
                  <td>{e.title}</td>
                  <td className={e.depasse ? 'probleme' : ''}>
                    {new Date(e.date).toLocaleDateString('fr-FR')}
                    {e.depasse ? ' (dépassée)' : ` (dans ${e.jours} jours)`}
                  </td>
                </tr>
              ))}
              {!echeances.length && (
                <tr><td colSpan={3} className="vide">Aucune échéance dans les deux mois.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {onglet === 'registre' && registre && <Registre registre={registre} />}

      {ouverte && (
        <Reglage demarche={ouverte} bases={data.bases_legales} lectureSeule={lectureSeule}
                 onFermer={() => setOuverte(null)}
                 onEnregistre={(m) => { setMessage(m); charger(); setOuverte(null) }} />
      )}
    </>
  )
}

function Reglage({ demarche, bases, lectureSeule, onFermer, onEnregistre }) {
  const [r, setR] = useState({
    finalite: demarche.finalite || '', base_legale: demarche.base_legale || 'mission_publique',
    pieces_mois: demarche.pieces_mois || 3, anonymisation_mois: demarche.anonymisation_mois || 12,
    suppression_mois: demarche.suppression_mois || 0,
  })
  const [erreur, setErreur] = useState('')
  const [justifier, setJustifier] = useState(null)
  const [champs, setChamps] = useState({ efface: demarche.efface, garde: demarche.garde })
  const maj = (champsR) => setR({ ...r, ...champsR })
  const base = bases.find((b) => b.key === r.base_legale)
  const sensibles = demarche.sensibles || []

  const relire = (r) => setChamps({ efface: r.efface, garde: r.garde })

  async function basculer(varname, personnel, justification = '') {
    try {
      relire(await api.marquerChamp(demarche.key, varname, personnel, justification))
      setErreur('')
    } catch (e) {
      // Une donnée sensible peut être conservée, mais il faut écrire pourquoi.
      const d = e.detail || {}
      if (d.champ) setJustifier({ varname, champ: d.champ, aide: d.detail })
      else setErreur(e.message)
    }
  }

  async function enregistrer() {
    try {
      await api.reglerRetention(demarche.key, r)
      onEnregistre(`« ${demarche.title} » : durées enregistrées.`)
    } catch (e) { setErreur(e.message) }
  }

  return (
    <div className="fenetre" role="dialog" aria-label="Conservation des données">
      <div className="fenetre-corps large">
        <h2>{demarche.title}</h2>
        {erreur && <p className="erreur" role="alert">{erreur}</p>}

        <div className="champ">
          <label htmlFor="fin">À quoi sert cette démarche</label>
          <input id="fin" value={r.finalite} disabled={lectureSeule}
                 onChange={(e) => maj({ finalite: e.target.value })} />
          <p className="aide">Une phrase. Elle figurera dans votre registre des traitements.</p>
        </div>

        <div className="champ">
          <label htmlFor="base">Ce qui autorise la commune à traiter ces données</label>
          <select id="base" value={r.base_legale} disabled={lectureSeule}
                  onChange={(e) => maj({ base_legale: e.target.value })}>
            {bases.map((b) => <option key={b.key} value={b.key}>{b.label}</option>)}
          </select>
          {base && <p className="aide">{base.aide}</p>}
        </div>

        <h3>Trois échéances, comptées après la clôture du dossier</h3>

        <div className="champ">
          <label htmlFor="p">Supprimer les pièces jointes après</label>
          <select id="p" value={r.pieces_mois} disabled={lectureSeule}
                  onChange={(e) => maj({ pieces_mois: Number(e.target.value) })}>
            {MOIS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <p className="aide">Les justificatifs sont ce qui pèse le plus lourd en cas de fuite,
            et ce qui sert le moins une fois la demande traitée.</p>
        </div>

        <div className="champ">
          <label htmlFor="a">Effacer les données personnelles après</label>
          <select id="a" value={r.anonymisation_mois} disabled={lectureSeule}
                  onChange={(e) => maj({ anonymisation_mois: Number(e.target.value) })}>
            {MOIS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <p className="aide">Le dossier reste compté dans vos statistiques, sans identifier
            personne.</p>
        </div>

        <div className="champ">
          <label htmlFor="s">Supprimer complètement le dossier après</label>
          <select id="s" value={r.suppression_mois} disabled={lectureSeule}
                  onChange={(e) => maj({ suppression_mois: Number(e.target.value) })}>
            <option value={0}>Jamais, garder les statistiques</option>
            {MOIS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>

        {sensibles.length > 0 && (
          <div className="avertissement">
            <strong>Cette démarche collecte {sensibles.length} donnée{sensibles.length > 1 ? 's' : ''} sensible{sensibles.length > 1 ? 's' : ''}</strong>
            {' '}: {sensibles.join(', ')}. Elles sont toujours effacées à l'échéance, et ne peuvent
            pas être conservées pour vos statistiques. Vérifiez qu'elles vous sont réellement
            nécessaires : ne pas les demander vaut mieux que bien les protéger.
          </div>
        )}

        <div className="deux-listes">
          <div>
            <h3>Ce qui sera effacé</h3>
            <ul className="liste-champs efface">
              {champs.efface.map((c) => (
                <li key={c.varname}>
                  <span>{c.label}</span>
                  {c.sensible && <span className="tag sensible">sensible</span>}
                  {!lectureSeule && (
                    <button className="lien-mini" onClick={() => basculer(c.varname, false)}>
                      garder
                    </button>
                  )}
                </li>
              ))}
              {!champs.efface.length && <li className="aide">Aucune donnée personnelle détectée.</li>}
            </ul>
          </div>
          <div>
            <h3>Ce qui sera gardé</h3>
            <ul className="liste-champs garde">
              {champs.garde.map((c) => (
                <li key={c.varname} className={c.sensible ? 'derogation' : ''}>
                  <span>
                    {c.label}
                    {c.sensible && (
                      <span className="motif-derogation" title={c.justification}>
                        conservée sur décision : {c.justification}
                      </span>
                    )}
                  </span>
                  {!lectureSeule && (
                    <button className="lien-mini" onClick={() => basculer(c.varname, true)}>
                      effacer
                    </button>
                  )}
                </li>
              ))}
              {!champs.garde.length && <li className="aide">Rien, le dossier sera vidé.</li>}
            </ul>
            <p className="aide">Des réponses fermées, qui ne désignent personne et permettent de
              compter. Corrigez si la détection s'est trompée.</p>
          </div>
        </div>

        <div className="ligne separee">
          <div className="pousse" />
          <button className="btn" onClick={onFermer}>Fermer</button>
          {!lectureSeule && <button className="btn pri" onClick={enregistrer}>Enregistrer</button>}
        </div>
      </div>

      {justifier && (
        <Justifier demande={justifier} onAnnuler={() => setJustifier(null)}
                   onValider={(motif) => {
                     basculer(justifier.varname, false, motif)
                     setJustifier(null)
                   }} />
      )}
    </div>
  )
}

// Conserver une donnée sensible reste possible : c'est la mairie qui est
// responsable du traitement, pas nous. Mais le choix s'écrit et se justifie.
function Justifier({ demande, onValider, onAnnuler }) {
  const [motif, setMotif] = useState('')

  return (
    <div className="fenetre" role="dialog" aria-label="Justifier la conservation">
      <div className="fenetre-corps">
        <h2>Conserver « {demande.champ} »</h2>
        <p className="avertissement">{demande.aide}</p>
        <div className="champ">
          <label htmlFor="just">Pourquoi cette donnée doit-elle être conservée ?</label>
          <textarea id="just" rows={3} value={motif} autoFocus
                    onChange={(e) => setMotif(e.target.value)}
                    placeholder="Par exemple : nécessaire au projet d'accueil individualisé tant que l'enfant est scolarisé dans la commune" />
          <p className="aide">Cette phrase apparaîtra dans votre registre des traitements, en
            face de la donnée concernée.</p>
        </div>
        <div className="ligne separee">
          <div className="pousse" />
          <button className="btn" onClick={onAnnuler}>Annuler</button>
          <button className="btn pri" disabled={!motif.trim()}
                  onClick={() => onValider(motif.trim())}>Conserver cette donnée</button>
        </div>
      </div>
    </div>
  )
}

function Registre({ registre }) {
  function imprimer() { window.print() }

  return (
    <div className="carte registre">
      <div className="ligne">
        <div>
          <h2>Registre des traitements</h2>
          <p className="aide">{registre.collectivite} · généré le
            {' '}{new Date(registre.genere_le).toLocaleDateString('fr-FR')}</p>
        </div>
        <div className="pousse" />
        <button className="btn" onClick={imprimer}>Imprimer ou enregistrer en PDF</button>
      </div>

      <p className="avertissement">{registre.avertissement}</p>

      {registre.traitements.map((t) => (
        <article className="traitement" key={t.demarche}>
          <h3>{t.demarche}</h3>
          <dl className="infos-liste">
            <div><dt>Finalité</dt><dd>{t.finalite}</dd></div>
            <div><dt>Ce qui l'autorise</dt><dd>{t.base_legale}</dd></div>
            <div><dt>Qui y accède</dt><dd>{t.destinataires}</dd></div>
            <div><dt>Données personnelles</dt><dd>{t.donnees_personnelles.join(', ') || '—'}</dd></div>
            {t.donnees_sensibles?.length > 0 && (
              <div><dt>Dont données sensibles</dt><dd>{t.donnees_sensibles.join(', ')}</dd></div>
            )}
            {t.derogations?.map((d) => (
              <div key={d.champ}><dt>« {d.champ} » conservée</dt><dd>{d.justification}</dd></div>
            ))}
            <div><dt>Conservées après clôture</dt>
              <dd>{libelle(t.anonymisation_mois)}, puis anonymisation</dd></div>
            <div><dt>Pièces jointes</dt><dd>supprimées après {libelle(t.pieces_mois)}</dd></div>
          </dl>
        </article>
      ))}
    </div>
  )
}

function Kpi({ label, valeur, detail, alerte }) {
  return (
    <div className={`kpi ${alerte ? 'alerte' : ''}`}>
      <span className="lbl">{label}</span>
      <strong>{valeur}</strong>
      <span className="detail">{detail}</span>
    </div>
  )
}

const libelle = (mois) => {
  if (!mois) return '—'
  if (mois % 12 === 0) return mois === 12 ? '1 an' : `${mois / 12} ans`
  return `${mois} mois`
}
